import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';


const useStyles = makeStyles()(theme => ({
  root: {
    padding: theme.spacing(2, 2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2, 3),
    }
  }
}));


export const InfoSection: React.FC<{ title?: string }> = ({ title, children }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      {title && (
        <Box mb={1}>
          <Typography variant="overline" color="secondary">{title}</Typography>
        </Box>
      )}
      {children}
    </Box>
  );
};
